const MESSAGES: Record<number, string> = {
  101: 'Dados da operação não informados.',
  102: 'Dados inválidos. Por favor, verifique se todos os dados requisitados foram informados corretamente.',
  202: 'Verifique se número do seu celular foi digitado corretamente. Digite um número TIM válido.',
  203: 'CPF inválido. Informe apenas 11 números do seu CPF, sem pontos ou traços.',
  204: 'O CPF informado já está cadastrado.',
  206: 'Email informado já consta em outro cadastro ativo.',
  207: 'Por questões de segurança, o acesso a este cadastro foi bloqueado temporariamente. Por favor, tente novamente em 24h.',
  208: 'O número TIM informado não encontra-se cadastrado no nosso sistema.',
  209: 'Desculpe, cadastro não efetuado. O cartão informado atingiu o número máximo de cadastros ativos.',
  210: 'Data de nascimento inválida. Informe a sua data de nascimento, sem barras ou espaços, no formato DDMMAA.',
  211: 'Desculpe, mas não podemos prosseguir com o cadastro. A idade mínima para realização de um cadastro no TIM Recarga Express é 15 anos.',
  214: 'O cartão foi bloqueado pelo seu emissor por fraude. Favor cadastrar outro cartão.',
  215: 'Usuário não habilitado para logar no sistema.',
  216: 'Cartão ou Usuário não habilitado para realizar alterações.',
  221: 'Desculpe. O limite de números TIM associados ao seu cadastro foi atingido.',
  223: 'O cartão inserido já está cadastrado. Escolha como opção de pagamento e tente novamente.',
  229: 'Seu cartão já foi alterado nos últimos 30 dias. Aguarde o fim deste período e tente novamente.',
  230: 'Por questões de segurança, o acesso a este cadastro foi bloqueado temporariamente. Por favor, tente novamente em 24h.',
  233: 'Número TIM de dependente é não pode ser cadastrado.',
  234: 'Este número TIM está associado a um cadastro ativo. É necessário que haja a desassociação para que ele possa prosseguir em um cadastro independente.',
  236: 'Desculpe. Este número TIM não pode ser associado ao seu cadastro.',
  240: 'O cadastro do número TIM não pôde ser realizado pois ainda existe uma pendência em seu cadastro. Por favor, faça uma recarga para o número TIM titular do cadastro.',
  241: 'Você excedeu a quantidade de alterações de números TIM cadastrados como dependentes.',
  242: 'Seu número de telefone agora possui 9 dígitos. Favor informar o nono dígito.',
  243: 'Acesso ao site inválido.',
  244: 'Desculpe. Cadastro não efetuado. O CPF informado atingiu o número máximo de cadastros ativos.',
  245: 'Sua sessão foi expirada ou é inválida.',
  246: 'Você ainda não realizou o seu cadastro, para acessar esta área é necessário o cadastro no serviço',
  262: 'Você está no período de carência por ter excluído seu cadastro. Tente novamente dentro de alguns dias',
  263: 'Não é possível realizar a recarga com esse cartão. Por favor, utilize outro cartão ou selecione outra forma de pagamento.',
  302: 'Desculpe. A autorização de pagamento não foi concedida. Tente novamente e, caso o resultado persista, entre em contato com o emissor do seu cartão.',
  303: 'Desculpe. A confirmação de pagamento junto à operadora do cartão não foi aceita. Tente novamente.',
  402: 'Desculpe. O valor de recarga informado é inválido. Tente novamente mais tarde.',
  403: 'Este número TIM não possui plano compatível com a transação.',
  404: 'Telefone não habilitado para utilização do serviço.',
  405: 'Recarga não permitida.',
  415: 'Desculpe. O valor selecionado ultrapassa o limite permitido para a sua primeira recarga. Por favor, tente novamente com outro valor.',
  416: 'Ação não permitida! Após a sua 1a Recarga você deve esperar 30 dias para recarregar novamente. A partir da 2a Recarga este intervalo é de apenas 24 horas.',
  417: 'Verifique quando foi feita sua última recarga, aguarde 24h e recarregue novamente.',
  418: 'Desculpe. O valor selecionado ultrapassa o limite permitido para o seu perfil. Por favor, tente novamente com outro valor.',
  419: 'O Cliente não possui recarga válida.',
  420: 'Por razões de segurança, o cartão informado não pode ser utilizado, por favor realize uma nova tentativa de recarga com um outro cartão.',
  421: 'Limite de recargas mensais excedido. Tente novamente após o término da carência.',
  422: 'Desculpe. Sua transação não foi efetuada. O cartão utilizado excedeu o limite mensal permitido. Por favor, utilize outro cartão ou tente novamente dentro de alguns dias.',
  423: 'Falha ao recuperar a última recarga do cliente.',
  424: 'Desculpe. Sua transação não foi efetuada. Você excedeu o limite diário permitido. Tente novamente em 24h.',
  425: 'Desculpe. Sua transação não foi efetuada. Você excedeu o limite mensal permitido. Tente novamente após este período.',
  426: 'O valor de recarga deve ser maior do que o valor selecionado.',
  427: 'Você selecionou um valor de recarga que ainda não está habilitado para o seu perfil de consumo. Por favor, selecione outro valor.',
  428: 'Verifique quando foi feita sua última recarga, aguarde 5 minutos e recarregue novamente.',
  429: 'Recarga não efetuada devido ao limite inicial do primeiro mês de cadastro. Aguarde 30 dias da data de quando foi feita a sua primeira recarga e tente novamente. A partir da sua segunda recarga, o intervalo mínimo necessário entre recargas será de apenas 24h.',
  430: 'Recarga não efetuada devido ao limite inicial do primeiro mês de cadastro. Por favor, utilize outro cartão ou aguarde 30 dias da data de quando foi feita a primeira recarga desse cartão. A partir da sua segunda recarga, o intervalo mínimo necessário entre recargas será de apenas 24h.',
  435: 'Cliente já tem uma recarga com mesma característica em intervalo pequeno.',
  438: 'Você atingiu o limite de compra no cartão selecionado. Por favor, utilize outro cartão',
  500: 'Cliente não encontrado com os dados enviados.',
  600: 'Falha ao expirar do cadastro do cliente',
  601: 'Falha ao iniciar o processo de expiração cadastro',
  602: 'Falha ao realizar a tarefa de lembrete de expiração de cadastro de titulares',
  603: 'Falha ao realizar a tarefa de lembrete de expiração de cadastro de dependentes',
  604: 'Falha ao expirar do cadastro do dependente',
  605: 'Falha ao iniciar o processo de expiração cadastro de dependente',
  606: 'Falha ao iniciar o processo de comunicação de migração de perfil',
  801: 'A consulta ao seu telefone não retornou valores para recarga',
  905: 'Não foi possível gerar sua chave Pix. Acesse o nosso sistema e faça uma nova recarga.',
  998: 'Não foi possível listar os valores disponíveis de recarga. Tente novamente mais tarde.',
  999: 'O método de pagamento selecionado está indisponível porque não possui lista de valores de recarga disponível.',
  1000: 'Token digitado não confere. Favor tentar novamente.',
  1001: 'Sua sessão expirou. Por favor, faça o login novamente.',
  1002: 'Sessão inválida. Por favor, faça o login e tente novamente.',
  1003: 'Você realizou muitas requisições em um curto período de tempo. Aguarde alguns instantes e tente novamente',
  1004: 'Para realizar uma programada, primeiro você precisa fazer uma recarga',
};

function setMessageToCodes(message: string, codes: number[]) {
  codes.forEach(code => {
    MESSAGES[code] = message;
  });
}

setMessageToCodes(
  'Os dados informados não são de um cliente cadastrado.',
  [200, 205, 212],
);

setMessageToCodes(
  'Problema na geração da chave Pix. Tente novamente mais tarde, ou escolha outro meio de pagamento.',
  [902, 904],
);

setMessageToCodes(
  'Este número TIM já encontra-se cadastrado no TIM Recarga Express.',
  [201, 228],
);

setMessageToCodes(
  'Você atingiu o número máximo de cartões associados. Exclua um cartão e tente novamente.',
  [222, 227],
);

setMessageToCodes(
  'Este número TIM foi desassociado de outro cadastro recentemente e ainda não pode ser associado a outro cadastro. Por favor, tente novamente em alguns dias.',
  [232, 235],
);

setMessageToCodes(
  'Este número TIM está associado a um cadastro ativo. É necessário que haja a desassociação para que você possa prosseguir com esta operação.',
  [231, 237],
);

setMessageToCodes(
  'Desculpe. Não foi possível prosseguir com a operação. Este número TIM foi cancelado há menos de 30 dias e ainda não está habilitado para efetuar um novo cadastro. Por favor, tente novamente ao fim deste período.',
  [213, 238],
);

setMessageToCodes(
  'Seu pagamento não foi autorizado pelo emissor do cartão.',
  [300, 301, 305, 308],
);

setMessageToCodes(
  'Você atingiu o seu limite de compra por cartão neste canal. Tente novamente outro dia ou procure outro canal de recarga Tim.',
  [434, 801, 903],
);

const ATTENTION_CODES = new Set([1001, 999, 1004]);

export const getTranslatedMessage = (
  code: number,
): { title: string; message: string } => {
  if (Object.prototype.hasOwnProperty.call(MESSAGES, code)) {
    const title = ATTENTION_CODES.has(code) ? 'Atenção' : 'Erro!';
    const message = MESSAGES[code];
    return { title, message };
  }

  return {
    title: 'Serviço indisponível',
    message:
      'Desculpe. O serviço está temporariamente indisponível. Tente novamente mais tarde.',
  };
};
